import { gql } from '@apollo/client'

export const CREATE_EMPLOYEE_REPORT = gql`
  mutation ($employee_report: EmployeeReportInput!) {
    createEmployeeReport(employee_report: $employee_report) {
      id
      _id
      status
      start_time_iso_date
      end_time_iso_date
      customer_id
      assignment_id
      employee_id
      data {
        total_work_time
        lunch_break_duration
        daily_allowance
        lunch_support
        driving_kilometers
        additional_details
      }
      createdAt
      updatedAt
    }
  }
`

export const DELETE_MULTIPLE_REPORTS = gql`
  mutation ($_ids: [String]!) {
    deleteMultipleEmployeeReports(_ids: $_ids)
  }
`

export const CHANGE_MULTIPLE_REPORTS_STATUS = gql`
  mutation ($_ids: [String]!, $status: EmployeeReportStatus!) {
    changeMultipleEmployeeReportStatus(_ids: $_ids, status: $status)
  }
`

export const UPDATE_EMPLOYEE_REPORT = gql`
  mutation ($employee_report: EmployeeReportInput!) {
    updateEmployeeReport(employee_report: $employee_report) {
      id
      _id
      status
      start_time_iso_date
      end_time_iso_date
      customer_id
      assignment_id
      employee_id
      data {
        total_work_time
        lunch_break_duration
        daily_allowance
        lunch_support
        driving_kilometers
        additional_details
      }
      createdAt
      updatedAt
    }
  }
`
export const DELETE_EMPLOYEE_REPORT = gql`
  mutation ($_id: String!) {
    deleteEmployeeReport(_id: $_id)
  }
`

export const QUERY_EMPLOYEE_REPORTS = gql`
  query ($queryParams: EmployeeReportsQueryParams!) {
    employeeReports(queryParams: $queryParams) {
      info {
        total
        page
        pages
      }
      data {
        id
        _id
        status
        start_time_iso_date
        end_time_iso_date
        customer_id
        assignment_id
        employee_id
        data {
          total_work_time
          lunch_break_duration
          daily_allowance
          lunch_support
          driving_kilometers
          additional_details
        }
        createdAt
        updatedAt
        meta {
          customer {
            _id
            name
            description
            business_identity_code
            city
            assignment {
              _id
              name
            }
          }
          employee {
            _id
            first_name
            last_name
            email
            social_security_number
            job_title
          }
        }
      }
    }
  }
`
